/* global chartLanguage, bocAmchart4 */

/**
 * Returns the proper quarter label  based on the date
 *
 * @param {date} date       the date object
 * @returns {string}        the proper string including the quarter
 */

bocAmchart4.quarterFunction = function (date) {
    var quarterLabel = "Q";
    if (chartLanguage === "fr") {
        quarterLabel = "T";
    }
    var month = date.getMonth();
    var quarter;
    if (month <= 2) {
        quarter = 1;
    } else if (month <= 5) {
        quarter = 2;
    } else if (month <= 8) {
        quarter = 3;
    } else {
        quarter = 4;
    }

    return date.getFullYear() + quarterLabel + quarter;
};

/**
 * Zoom the date axis if chart has dateZoom parameter
 * @param {am4charts.XYChart} chart The chart object
 * @returns {void}
 */
bocAmchart4.handlePreZoom = function (chart) {
    if (typeof chart.xAxes === "object") {
        var axis = chart.xAxes.getIndex(0);
        if (axis._className === "DateAxis") {
            var endDate, numberPart, endYear;
            if (typeof window.enddate !== 'undefined' && window.enddate !== '') {
                endDate = new Date(window.enddate);
                endYear = endDate.getFullYear();
            } else {
                endDate = new Date(axis.max);
                endYear = endDate.getFullYear();
            }
            if (chart.bocSettings.args.hasOwnProperty('datezoom')) {
                var zoomParam = chart.bocSettings.args.datezoom;
                numberPart = zoomParam.slice(0, -1);
                if (zoomParam.slice(-1) === "Y" && parseInt(numberPart).toString() === numberPart) {
                    axis.zoomToDates(
                        new Date(endYear - numberPart, 0, 1, 0, 0, 0),
                        endDate
                    );
                }
            }
        }
    }
};

bocAmchart4.convertTimeStringToSeconds = function (timeString) {
    let parts = timeString.split(":");
    let hours = parseInt(parts[0]);
    let minutes = parseInt(parts[1]);
    let seconds = parseFloat(parts[2]);
    return (hours * 60 + minutes) * 60 + seconds;
};


bocAmchart4.convertMDate = function (chart, dateString) {
    const year = dateString.slice(0, 4);
    const month = parseInt(dateString.slice(5), 10);
    const monthName = chart.dateFormatter.months[month - 1];

    if (monthName) {
        return `${monthName} ${year}`;
    } else {
        console.error("Invalid month", month);
    }
};
